import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=58afe600&scoped=true&"
import script from "./TaskStatus.vue?vue&type=script&lang=js&"
export * from "./TaskStatus.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatus.vue?vue&type=style&index=0&id=58afe600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58afe600",
  null
  
)

export default component.exports